// @flow

import { all, fork } from 'redux-saga/effects';

import { flatten, map, flowRight } from 'lodash/fp';

import actions from './actions/sagas';
import alert from './alerts/sagas';
import application from './application/sagas';
import appSettings from './app-settings/sagas';
import homes from './homes/sagas';
import aquireDevice from './acquire-devices/sagas';
import audioPlayer from './ui/sensor-logs/audio-player/sagas';
import authentication from './authentication/sagas';
import bulb from './products/bulbs/sagas';
import camera from './camera/sagas';
import config from './config/sagas';
import connectedCareInvite from './connected-care-invite/sagas';
import contactSensor from './products/contact-sensor/sagas';
import cookie from './cookies/sagas';
import dashboard from './dashboard/sagas';
import device from './devices/sagas';
import entitlement from './entitlements/sagas';
import groups from './groups/sagas';
import heatingHotwater from './products/heating-hotwater/sagas';
import heating from './products/heating/sagas';
import holidayMode from './holiday-mode/sagas';
import honeycomb from './honeycomb/sagas';
import hub from './hub/sagas';
import leakSensor from './products/leak-sensor/sagas';
import motionSensor from './products/motion-sensor/sagas';
import nano1Upgrade from './install-nano1-upgrade/sagas';
import notification from './notifications/sagas';
import powerConsumption from './power-consumption/sagas';
import product from './products/sagas';
import recipe from './recipes/sagas';
import schedule from './ui/schedule/sagas';
import senseSaga from './products/sense/sagas';
import textControl from './text-control/sagas';
import thermostat from './products/thermostat/sagas';
import translation from './translations/sagas';
import user from './user/sagas';
import weather from './weather/sagas';
import hueBridge from './install-hue-bridge/sagas';

const forkSagas = flowRight(all, map(fork), flatten);

export const synchronousSagas = {
    actions,
    holidayMode,
    alert,
    appSettings,
    application,
    aquireDevice,
    audioPlayer,
    authentication,
    bulb,
    camera,
    config,
    connectedCareInvite,
    cookie,
    device,
    entitlement,
    groups,
    heatingHotwater,
    heating,
    honeycomb,
    homes,
    hub,
    nano1Upgrade,
    notification,
    powerConsumption,
    product,
    senseSaga,
    textControl,
    thermostat,
    translation,
    user,
    weather,
    recipe,
    schedule,
    dashboard,
    leakSensor,
    motionSensor,
    contactSensor,
    hueBridge
};

export default function* root(): Generator<*, *, *> {
    yield forkSagas(Object.values(synchronousSagas));
}



// WEBPACK FOOTER //
// ./src/core/state/sagas-registration.js